import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_CommunityResourceLinkage = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_CommunityResourceLinkage' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Type</span>
                            <input type='text' id="txtContactType" name="txtContactType" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Person(s) Involved</span>
                            <input type='text' id="txtPersonInvolved" name="txtPersonInvolved" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumer Overall Affect</span>
                            <input type='text' id="txtOverallAffect" name="txtOverallAffect" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Service Plan Objectives/Interventions:</span>
                    <textarea id="txtYouthTreatmentPlan" name="txtYouthTreatmentPlan" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Behavior:</span>
                    <textarea id="txtBehavior" name="txtBehavior" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Intervention:</span>
                    <textarea id="txtIntervention" name="txtIntervention" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Response:</span>
                    <textarea id="txtResponse" name="txtResponse" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Plan:</span>
                    <textarea id="txtPlan" name="txtPlan" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbChildrenServices" name="cbChildrenServices" className='add-only' value="Department of Family and Children Services" /> <strong>Department of Family and Children Services (DFCS):</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'></td>
                        <td className='w-100'><span><strong>County</strong></span></td>
                        <td className='w-250'><span><strong>Address</strong></span></td>
                        <td className='w-150'><span><strong>City</strong></span></td>
                        <td className='w-50'><span><strong>State</strong></span></td>
                        <td className='w-50'><span><strong>Zip</strong></span></td>
                        <td className='w-100'><span><strong>Phone</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'><input type="checkbox" id="cbDFCS_1" name="cbDFCS_1" className='add-only' value="Clayton" /></td>
                        <td className='w-100'><span>Clayton</span></td>
                        <td className='w-250'><span>877 Battlecreek Road </span></td>
                        <td className='w-150'><span>Jonesboro</span></td>
                        <td className='w-50'><span>GA</span></td>
                        <td className='w-50'><span>30236</span></td>
                        <td className='w-100'><span>770-473-2300</span></td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'><input type="checkbox" id="cbDFCS_2" name="cbDFCS_2" className='add-only' value="Cobb" /></td>
                        <td className='w-100'><span>Cobb</span></td>
                        <td className='w-250'><span>325 Fairground Street</span></td>
                        <td className='w-150'><span>Marietta</span></td>
                        <td className='w-50'><span>GA</span></td>
                        <td className='w-50'><span>30060</span></td>
                        <td className='w-100'><span>770-528-5154</span></td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'><input type="checkbox" id="cbDFCS_3" name="cbDFCS_3" className='add-only' value="Dekalb" /></td>
                        <td className='w-100'><span>Dekalb</span></td>
                        <td className='w-250'><span>178 Sams Street</span></td>
                        <td className='w-150'><span>Decatur</span></td>
                        <td className='w-50'><span>GA</span></td>
                        <td className='w-50'><span>30030</span></td>
                        <td className='w-100'><span>404-370-5000</span></td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'><input type="checkbox" id="cbDFCS_4" name="cbDFCS_4" className='add-only' value="Douglas" /></td>
                        <td className='w-100'><span>Douglas</span></td>
                        <td className='w-250'><span>8473 Duralee Lane, Suite 100</span></td>
                        <td className='w-150'><span>Douglasville</span></td>
                        <td className='w-50'><span>GA</span></td>
                        <td className='w-50'><span>30134</span></td>
                        <td className='w-100'><span>770-489-3000</span></td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'><input type="checkbox" id="cbDFCS_5" name="cbDFCS_5" className='add-only' value="Fulton" /></td>
                        <td className='w-100'><span>Fulton</span></td>
                        <td className='w-250'><span>1249 Donald Lee Hollowell Pkwy</span></td>
                        <td className='w-150'><span>Atlanta</span></td>
                        <td className='w-50'><span>GA</span></td>
                        <td className='w-50'><span>30318</span></td>
                        <td className='w-100'><span> 404-206-5300 </span></td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'><input type="checkbox" id="cbDFCS_6" name="cbDFCS_6" className='add-only' value="Gwinnett" /></td>
                        <td className='w-100'><span>Gwinnett</span></td>
                        <td className='w-250'><span>446 W. Crogan Street </span></td>
                        <td className='w-150'><span>Lawrenceville</span></td>
                        <td className='w-50'><span>GA</span></td>
                        <td className='w-50'><span>30045</span></td>
                        <td className='w-100'><span>678-518-5500</span></td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'><input type="checkbox" id="cbDFCS_7" name="cbDFCS_7" className='add-only' value="Henry" /></td>
                        <td className='w-100'><span>Henry</span></td>
                        <td className='w-250'><span>125 Henry Parkway </span></td>
                        <td className='w-150'><span>McDonough</span></td>
                        <td className='w-50'><span>GA</span></td>
                        <td className='w-50'><span>30253</span></td>
                        <td className='w-100'><span>770-954-2014</span></td>
                    </tr>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-30'><input type="checkbox" id="cbDFCS_8" name="cbDFCS_8" className='add-only' value="Other" /></td>
                        <td className='w-100'><span>Other: </span></td>
                        <td className='w-600'><input type="text" id="txtOtherAddressCityStatePhone" name="txtOtherAddressCityStatePhone" placeholder='Address, City ,State, Phone' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCommunityFoodBank" name="cbCommunityFoodBank" className='add-only' value="Community Food Bank" /> <strong>Community Food Bank</strong>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Fulton</span></td>
                        <td><span>732 Joseph E. Lowery Blvd, NW</span></td>
                        <td><span>Atlanta</span></td>
                        <td><span>GA</span></td>
                        <td><span>30318</span></td>
                        <td><span>404-892-9822</span></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Gwinnett</span></td>
                        <td><span>1125 Winter Park Lane  </span></td>
                        <td><span>Norcross</span></td>
                        <td><span>GA</span></td>
                        <td><span>30093</span></td>
                        <td><span>404-468-4576</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbHomelessShelter" name="cbHomelessShelter" className='add-only' value="Homeless Shelter" /> <strong>Homeless Shelter</strong>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Fulton</span></td>
                        <td><span>1035 Donnelly Avenue SW</span></td>
                        <td><span>Atlanta</span></td>
                        <td><span>GA</span></td>
                        <td><span>30310</span></td>
                        <td><span>404-755-3353 </span></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Gwinnett</span></td>
                        <td><span>3495 Suite B Sugarloaf Parkway</span></td>
                        <td><span>Lawerenceville</span></td>
                        <td><span>GA</span></td>
                        <td><span>30044</span></td>
                        <td><span>678-376-8950</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbBatteredWomen" name="cbBatteredWomen" className='add-only' value="Shelters For Battered Women" /> <strong>Shelters For Battered Women</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbShelterBatteredWomen" name="cbShelterBatteredWomen" className='add-only' value="Shelter For Battered Women" /> Shelter For Battered Women
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Fulton</span></td>
                        <td><span>1475 Peachtree Street</span></td>
                        <td><span>Atlanta</span></td>
                        <td><span>GA</span></td>
                        <td><span>30309</span></td>
                        <td><span>404-873-1766</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbBatteredWomenChildren" name="cbBatteredWomenChildren" className='add-only' value="Georgia Advocates For Battered Women and Children" /> Georgia Advocates For Battered Women and Children
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Fulton</span></td>
                        <td><span>250 Georgia Ave, SE </span></td>
                        <td><span>Atlanta</span></td>
                        <td><span>GA</span></td>
                        <td><span>30312</span></td>
                        <td><span>404-524-3847</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCrisisIntervention" name="cbCrisisIntervention" className='add-only' value="YWCA of Cobb County Crisis Intervention" /> YWCA of Cobb County Crisis Intervention
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Cobb</span></td>
                        <td><span>48 Henderson Street</span></td>
                        <td><span>Marietta</span></td>
                        <td><span>GA</span></td>
                        <td><span>30064</span></td>
                        <td><span>770-427-3390</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDomesticVolence" name="cbDomesticVolence" className='add-only' value="Womens Resource Center to End Domestic Volence" /> Women's Resource Center to End Domestic Volence
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Dekalb</span></td>
                        <td><span>PO Box 171</span></td>
                        <td><span>Decatur</span></td>
                        <td><span>GA</span></td>
                        <td><span>30031</span></td>
                        <td><span>404-508-9717</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbOther" name="cbOther" className='add-only' value="Other" /> Other:
                            <input type="text" id="txtOtherAddressCityStateZip" name="txtOtherAddressCityStateZip" className='add-only' value="Partnership for Domestic Violence 619 Edgewood Ave. Suite101 Atlanta GA Gwinnett Hotline 770-963-9799" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTutoringServices" name="cbTutoringServices" className='add-only' value="Tutoring Services" /> <strong>Tutoring Services</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTS_1" name="cbTS_1" className='add-only' value="All About Math" /> All About Math (D/B/A Math Doctor Learning)
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Cobb</span></td>
                        <td><span>3115 Roswell Road Northeast, Suite 202</span></td>
                        <td><span>Marietta</span></td>
                        <td><span>GA</span></td>
                        <td><span>30062</span></td>
                        <td><span>770-509-1042</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTS_2" name="cbTS_2" className='add-only' value="A to Z In-Home Tutoring" /> A to Z In-Home Tutoring
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Fulton</span></td>
                        <td><span>1830 Water Place, Suite 200</span></td>
                        <td><span>Atlanta</span></td>
                        <td><span>GA</span></td>
                        <td><span>30339</span></td>
                        <td><span>770-916-9031</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTS_3" name="cbTS_3" className='add-only' value="Reading Phonics Math and More" /> Reading, Phonics, Math and More
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Dekalb</span></td>
                        <td><span>737 Main Street</span></td>
                        <td><span>Stone Mountain</span></td>
                        <td><span>GA</span></td>
                        <td><span>30083</span></td>
                        <td><span>770-413-6868</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbOther_1" name="cbOther_1" className='add-only' value="Other" /> Other:
                            <input type="text" id="txtOtherAddressCityState" name="txtOtherAddressCityState" className='add-only' value="Gwinett Tutoring 235 Thornbush Lane Lawerenceville GA 30078 404-219-5153" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMentoringServices" name="cbMentoringServices" className='add-only' value="Mentoring Services" /> <strong>Mentoring Services</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMS_1" name="cbMS_1" className='add-only' value="Big Brothers Big Sisters of Metro Atlanta" /> Big Brothers Big Sisters of Metro Atlanta
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Fulton</span></td>
                        <td><span>100 Edgewood Avenue, Suite 710</span></td>
                        <td><span>Atlanta</span></td>
                        <td><span>GA</span></td>
                        <td><span>30303</span></td>
                        <td><span>404-601-7000</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMS_2" name="cbMS_2" className='add-only' value="Boys and Girls Clubs of Metro Atlanta" /> Boys and Girls' Clubs of Metro Atlanta
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Cobb</span></td>
                        <td><span>785 Fontaine Road SW</span></td>
                        <td><span>Mabelton</span></td>
                        <td><span>GA</span></td>
                        <td><span>30126</span></td>
                        <td><span>404-601-7000</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMS_3" name="cbMS_3" className='add-only' value="Lawerenceville Boys & Girls" /> Lawerenceville Boys & Girls
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><span>Gwinnett</span></td>
                        <td><span>235 Thornbush Lane</span></td>
                        <td><span>Lawerenceville</span></td>
                        <td><span>GA</span></td>
                        <td><span>30317</span></td>
                        <td><span>404-219-5153</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbOther_2" name="cbOther_2" className='add-only' value="Other" /> Other
                            <input type="text" id="txtOtherAddressCityStateZipPhone" name="txtOtherAddressCityStateZipPhone" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Staff Signature / Credentials / Title </td>
                        <td className='small w-375'>Date </td>
                    </tr>
                </table>






            </div>
        </form>

    )
}